var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (currentSection, profile, sections, undefined) {
var id = profile.get('id');
function transform(section) {
var map = { collection: 'works', articles: 'articles' };
return map[section] || section;
}
buf.push("<nav class=\"partner-tabs garamond-tablist\">");
if ( sections.length > 1)
{
// iterate sections
;(function(){
  var $$obj = sections;
  if ('number' == typeof $$obj.length) {

    for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
      var section = $$obj[index];

if ( index > 0)
{
buf.push("<span class=\"garamond-tab-separator\"></span>");
}
buf.push("<a" + (jade.attr("href", "/" + (id) + "/" + (section) + "", true, true)) + (jade.attr("data-section", section, true, true)) + (jade.cls(['garamond-tab','partner-route-link',(section == currentSection ? 'is-active' : 'is-inactive')], [null,null,true])) + ">" + (jade.escape(null == (jade_interp = transform(section)) ? "" : jade_interp)) + "</a>");
    }

  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;      var section = $$obj[index];

if ( index > 0)
{
buf.push("<span class=\"garamond-tab-separator\"></span>");
}
buf.push("<a" + (jade.attr("href", "/" + (id) + "/" + (section) + "", true, true)) + (jade.attr("data-section", section, true, true)) + (jade.cls(['garamond-tab','partner-route-link',(section == currentSection ? 'is-active' : 'is-inactive')], [null,null,true])) + ">" + (jade.escape(null == (jade_interp = transform(section)) ? "" : jade_interp)) + "</a>");
    }

  }
}).call(this);

}
buf.push("</nav>");}.call(this,"currentSection" in locals_for_with?locals_for_with.currentSection:typeof currentSection!=="undefined"?currentSection:undefined,"profile" in locals_for_with?locals_for_with.profile:typeof profile!=="undefined"?profile:undefined,"sections" in locals_for_with?locals_for_with.sections:typeof sections!=="undefined"?sections:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;